import { getVatRate } from './vatUtil';
import { parseQuantity } from './quantityUtil';

export const formatCurrency = (price: number = 0, currencyCode: string = 'usd') => {
 
  const locale = navigator.languages[0]
  try {
    return new Intl.NumberFormat(locale ?? 'en-GB', {
      style: 'currency',
      currency: currencyCode,
    }).format(price)
  } catch(e) {
    return `${currencyCode}${price}`
  }
}

export const calculateVAT = (item: any, date?: any) => {
  if (!item.VAT) return 0;
  const discountedPrice = item.rate - (item.discountPerItem || 0);
  console.log('Calculating VAT for item:', getVatRate(date));
  return discountedPrice * parseQuantity(item.quantity.quantityValue) * getVatRate(date);
};